import { render, staticRenderFns } from "./BetSlip.vue?vue&type=template&id=17b3a474"
import script from "./BetSlip.vue?vue&type=script&lang=js"
export * from "./BetSlip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports